module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pulmonology3.f641ab0f.png";